export const formatMultiple = ({ docs, agent, obie }: any) => {
  const parts = [docs && 'Docs', agent && 'Agent', obie && "Obie"].filter(Boolean);
  return parts.length ? `[${parts.join('/')}]` : '[]';
};